import type { TMessages } from '@/types/TMessages'

export const messages = {
  header: 'Производители',
  manufacturersCount: '{formattedNumber} производител{number, plural, one {ь} few {я} other {ей}}',
} satisfies TMessages
